import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppRoutingModule } from './app-routing.module';
import { NavmenuComponent } from 'src/app/shared/components/navmenu/navmenu.component';
import { AppComponent } from './app.component';
import { PopuptestComponent } from 'src/app/shared/components/popuptest/popuptest.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppService } from 'src/core/services/app-service';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { LoginComponent } from './modules/login/login.component';
import { LoginAltComponent } from './modules/login-alt/login-alt.component';
import { SharedModule } from './shared/shared-module';
import { AlertSummaryModule } from './shared/components/alert-summary/alert-summury.module';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { DialogBoxDemoComponent } from './shared/components/demo/dialog-box-demo/dialog-box-demo.component';
import { DialogBoxModule } from './shared/components/dialog-box/dialog-box.module';
import { DialogBoxComponent } from './shared/components/dialog-box/dialog-box.component';
import { MapPropertyListPipe } from './shared/pipes/map-property-list.pipe';
import { EncounterReportComponent } from './modules/encounter-report/encounter-report.component';
import { CdkDetailRowDirective } from './modules/encounter-report/cdk-detail-row.directive';
import { InfiniteAutocompleteModule } from './shared/components/controls/regular-edit/autocomplete/infinite-autocomplete/infinite-autocomplete.module';
import { PageNotFoundComponent } from './modules/page-not-found/page-not-found.component';
import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ErrorInterceptor } from 'src/core/interceptors/ErrorInterceptor';
import { UserIdleModule } from 'angular-user-idle';
import { environment } from 'src/environments/environment';
import { MultiTagsModule } from './shared/components/controls/regular-edit/autocomplete/multi-tags/multi-tags.module';
import { MessageAddComponent } from './modules/message/message-add/message-add.component';
import { HomepageComponent } from './modules/homepage/homepage.component';
import { MessageListComponent } from './modules/message/message-list/message-list.component';
import { MessageBlockComponent } from './modules/message/message-block/message-block.component';
import { SortingMenuModule } from './shared/components/sorting-menu/sorting-menu.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SafeHtmlPipe } from './shared/pipes/safe-html.pipe';
import { DialogAvatarModule } from './shared/components/dialog-avatar/dialog-avatar.module';
import { DialogAvatarComponent } from './shared/components/dialog-avatar/dialog-avatar.component';
import { DialogChangeInstanceComponent } from './shared/components/dialog-change-instance/dialog-change-instance.component';
import { DialogChangeInstanceModule } from './shared/components/dialog-change-instance/dialog-change-instance.module';
import { MyAccountComponent } from './modules/my-account/my-account.component';
import { DialogJsonBoxModule } from './shared/components/dialog-json-box/dialog-json-box.module';


@NgModule({
  declarations: [
    NavmenuComponent,
    AppComponent,
    HomepageComponent,
    MessageListComponent,
    MessageBlockComponent,
    MessageAddComponent,
    MyAccountComponent,
    PopuptestComponent,
    // DialogBoxDemoComponent,
    LoginComponent,
    LoginAltComponent,
    EncounterReportComponent,
    PageNotFoundComponent,
    SafeHtmlPipe,
    CdkDetailRowDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FlexLayoutModule,
    LayoutModule,
    MaterialModule,
    NgScrollbarModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatMomentDateModule,
    AlertSummaryModule,
    DialogBoxModule,
    DialogJsonBoxModule,
    DialogAvatarModule,
    DialogChangeInstanceModule,
    SharedModule,
    ScrollingModule,
    InfiniteAutocompleteModule,
    MultiTagsModule,
    SortingMenuModule,
    CKEditorModule,
    SimpleNotificationsModule.forRoot({
      // icons: {
      //   success: '<i class="icon-check-sign icon-3x left"></i>',
      //   alert: '<i class="icon-exclamation icon-3x left"></i>',
      //   error: '<i class="icon-bug icon-3x left"></i>',
      //   info: '<i class="icon-info icon-3x left"></i>',
      //   warn: '<i class="icon-warning-sign icon-3x left"></i>'
      // },
      // rtl: true,
      timeOut: 4000,
      // showProgressBar: true,
      // pauseOnHover: true,
      // clickToClose: true,
      // clickIconToClose: true,
      theClass: 'custom-snackbar'
    }),
    // https://www.npmjs.com/package/angular-user-idle
    UserIdleModule.forRoot({idle: environment.idleDuration, timeout: 1, ping: 20000})
  ],
  providers: [
    { provide: 'ORIGIN_URL', useValue: location.origin },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AppService],
  bootstrap: [AppComponent],
  entryComponents: [/*DialogBoxDemoComponent,*/ DialogBoxComponent, DialogAvatarComponent, DialogChangeInstanceComponent]
})
export class AppModule {}
